<template>
  <article
    class="message"
    :class="messageClass">
    <button
      class="delete"
      :class="buttonClass"
      v-if="closable"
      @click="close()">
    </button>
    <div class="message-body">
      <slot>
      </slot>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    type: {
      type: String
    },
    closable: {
      type: Boolean,
      default: true
    },
    timer: {
      type: [Number],
      default: 6000
    }
  },
  computed: {
    messageClass() {
      return {
        'is-info': this.type == 'info',
        'is-success': this.type == 'success',
        'is-warning': this.type == 'warning',
        'is-danger': this.type == 'danger',
        'visible': this.value
      }
    },
    buttonClass() {
      return {
        'is-info': this.type == 'info',
        'is-success': this.type == 'success',
        'is-warning': this.type == 'warning',
        'is-danger': this.type == 'danger'
      }
    }
  },
  watch: {
    value(v) {
      if (v) {
        var vm = this;
        setTimeout(() => { vm.close() }, vm.timer);
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  position: fixed;
  left: 1em;
  bottom: 1em;
  padding-right: 1em;
  transition: transform 500ms ease;
  transform: translateY(200%);

  .delete {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .message-body {
    position: relative;
  }

  &.visible {
    transform: translateY(0%);
  }
}
</style>
